module.exports = __webpack_public_path__ + "static/media/user-large.69c611a8.svg";